export const UPS_PACKAGING_CODES = [
  // Shipment > ShipmentServiceOptions > Package > Packaging > Code
  // Note: Only packaging type code 02 is applicable to Ground Freight Pricing. Package type 24, or 25 is only allowed for shipment without return service.
  { label: "UPS Letter", value: "01" },
  { label: "Customer Supplied Package", value: "02" },
  { label: "Tube", value: "03" },
  { label: "PAK", value: "04" },
  { label: "UPS Express Box", value: "21" },
  { label: "UPS 25KG Box", value: "24" },
  { label: "UPS 10KG Box", value: "25" },
  { label: "Pallet", value: "30" },
  { label: "Small Express Box", value: "2a" },
  { label: "Medium Express Box", value: "2b" },
  { label: "Large Express Box", value: "2c" },
  { label: "Flats", value: "56" },
  { label: "Parcels", value: "57" },
  { label: "BPM", value: "58" },
  { label: "First Class", value: "59" },
  { label: "Priority", value: "60" },
  { label: "Machineables", value: "61" },
  { label: "Irregulars", value: "62" },
  { label: "Parcel Post", value: "63" },
  { label: "BPM Parcel", value: "64" },
  { label: "Media Mail", value: "65" },
  { label: "BPM Flat", value: "66" },
  { label: "Standard Flat", value: "67" },
];
